<!--
  Snackbar component

  options: 

  display     - true to flash the snackbar
  html        - html to display (any user content should be sanitised first)
  icon        - Optional icon name & icon color to determine the default icon 
  attrs       - Optional v-snackbar exposed attributes
-->

<template>
  <div class="AppSnackbar">
    <div class="sr-only" aria-live="polite">
      <span
        v-if="snackbar.html"
        v-html="snackbar.html"
        data-testid="snackbar-accessibility-div"
      ></span>
    </div>
    <v-snackbar v-model="display" v-bind="attrs">
      <div class="pt-4 pb-4">
        <v-icon dark right :color="snackbar.icon.color">{{
          snackbar.icon.name
        }}</v-icon>
        <span
          class="ml-3"
          :class="snackbar.closeBtn ? 'mr-6' : ''"
          v-if="snackbar.html"
          v-html="snackbar.html"
          data-testid="snackbar-content"
        ></span>
        <v-icon
          v-if="snackbar.closeBtn"
          color="primary"
          aria-label="close"
          @click="close"
          >mdi-close-circle</v-icon
        >
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'AppSnackbar',
  computed: {
    snackbar() {
      return this.$store.state.snackbar || { icon: {} }
    },
    display: {
      get() {
        return this.snackbar ? this.snackbar.display : false
      },
      set() {
        this.$store.dispatch('hideSnackbar')
      }
    },
    attrs() {
      const defaults = {
        light: true,
        bottom: true,
        color: 'white',
        left: true,
        'multi-line': false,
        right: false,
        top: false,
        vertical: false
      }
      if (this.snackbar?.timeout) {
        defaults.timeout = this.snackbar.timeout
      } else {
        defaults.timeout = 5000
      }
      return { ...defaults, ...this.snackbar.attrs }
    }
  },
  methods: {
    close() {
      this.$store.dispatch('hideSnackbar')
    }
  }
}
</script>

<style scoped lang="scss">
.AppSnackbar .v-snack {
  font-size: 16px;
  color: #121212;
}
::v-deep .v-snack__content {
  padding: 16px 16px;
  line-height: 1.5rem;
}

::v-deep .v-snack__wrapper {
  max-width: 900px !important;
}
.theme--light.v-icon.v-icon--link:focus {
  border: none;
  box-shadow: 0 0 0 2px $color-primary;
}
</style>
